/* PQ PDP — veterinary diet gate (loaded only when the pq_vet_declaration block is on the page).
 * 1. Intercepts Add to cart on the product form(s) in this section and shows the confirmation declaration.
 * 2. On "I agree" adds the item through the theme's own form/cart bridge with line-item properties
 *    (pet name, declaration + version, accepted-at) — nothing else is written anywhere.
 * 3. Vet diets are one-off purchases for now: Appstle/selling-plan pickers inside the gated form are removed.
 * No customer data is stored by this script beyond the cart line itself. Pet name input is Clarity-masked.
 */
(function () {
  'use strict';
  if (window.__pqVetGateInit) return;
  window.__pqVetGateInit = true;

  var FORM_SEL = 'form[action*="/cart/add"]';
  var CTA_SEL = FORM_SEL + ' [data-to-cart], ' + FORM_SEL + ' button[type="submit"], ' + FORM_SEL + ' input[type="submit"]';
  var state = { gate: null, section: null, modal: null, form: null, trigger: null, lastFocus: null };

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function adopt() {
    var gate = q('[data-pq-vet-gate]');
    if (!gate) { state.gate = null; return false; }
    if (state.gate === gate && state.modal && state.modal.isConnected) return true;
    // theme editor re-render: drop a stale modal we previously moved to <body>
    if (state.modal && state.modal.parentElement === document.body) state.modal.remove();
    state.gate = gate;
    state.section = gate.closest('.shopify-section') || gate.closest('section') || document.body;
    state.modal = q('[data-pq-vet-modal]', gate);
    if (state.modal) document.body.appendChild(state.modal);
    oneOffOnly();
    return true;
  }

  /* ---- one-off only: no subscription pickers inside gated forms (until renewal confirmation is agreed) ---- */
  function oneOffOnly() {
    if (!state.section) return;
    qa(FORM_SEL, state.section).forEach(function (form) {
      qa('selling-plan, .appstle_sub_widget, .appstle_subscription_wrapper, [class^="appstle_"][class*="widget"], input[name="selling_plan"]', form).forEach(function (el) { el.remove(); });
    });
    qa('.appstle_sub_widget, .appstle_subscription_wrapper', state.section).forEach(function (el) { el.remove(); });
  }

  /* ---- modal ---- */
  function variantTitle(form) {
    try {
      var map = JSON.parse(state.gate.getAttribute('data-variants') || '{}');
      var id = form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : '';
      return map[id] || '';
    } catch (_) { return ''; }
  }
  function showError(msg) {
    var el = q('[data-pq-vet-error]', state.modal);
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  function open(form, trigger) {
    if (!adopt() || !state.modal) return false;
    state.form = form; state.trigger = trigger || null; state.lastFocus = document.activeElement;
    var vt = q('[data-pq-vet-variant]', state.modal); if (vt) vt.textContent = variantTitle(form);
    var pet = q('[data-pq-vet-pet]', state.modal);
    if (pet) { try { pet.value = sessionStorage.getItem('pq-vet-pet') || pet.value || ''; } catch (_) {} }
    qa('[data-pq-vet-ack]', state.modal).forEach(function (c) { c.checked = false; });
    showError('');
    state.modal.hidden = false;
    document.documentElement.classList.add('pq-vet-open');
    requestAnimationFrame(function () { state.modal.classList.add('is-open'); if (pet) pet.focus(); });
    return true;
  }
  function close(restoreFocus) {
    if (!state.modal) return;
    state.modal.classList.remove('is-open');
    document.documentElement.classList.remove('pq-vet-open');
    var m = state.modal; setTimeout(function () { if (!m.classList.contains('is-open')) m.hidden = true; }, 180);
    if (restoreFocus && state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus(); } catch (_) {} }
    state.form = null; state.trigger = null;
  }

  function sydneyNow() {
    try {
      return new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date());
    } catch (_) { return new Date().toISOString(); }
  }
  function setProp(form, key, value) {
    var ref = document.createElement('input'); ref.type = 'hidden'; ref.name = 'customPropertyReference'; ref.value = key; ref.setAttribute('data-pq-vet-prop', '');
    var val = document.createElement('input'); val.type = 'hidden'; val.name = 'properties[' + key + ']'; val.value = value; val.setAttribute('data-pq-vet-prop', '');
    form.appendChild(ref); form.appendChild(val);
  }
  function agree() {
    var form = state.form, trigger = state.trigger, gate = state.gate;
    if (!form || !gate) { close(true); return; }
    var pet = q('[data-pq-vet-pet]', state.modal);
    var name = pet ? pet.value.replace(/\s+/g, ' ').trim() : '';
    if (!name) { showError("Please enter your pet's name."); if (pet) pet.focus(); return; }
    if (name.length > 60) name = name.slice(0, 60);
    var ticks = qa('[data-pq-vet-ack]', state.modal);
    if (ticks.length && ticks.some(function (c) { return !c.checked; })) { showError('Please confirm each statement to continue.'); return; }
    try { sessionStorage.setItem('pq-vet-pet', name); } catch (_) {}

    var version = gate.getAttribute('data-version') || '';
    var summary = gate.getAttribute('data-summary') || '';
    var domain = gate.getAttribute('data-domain') || location.hostname;
    qa('[data-pq-vet-prop]', form).forEach(function (el) { el.remove(); });
    setProp(form, gate.getAttribute('data-prop-pet') || '_Pet name', name);
    setProp(form, gate.getAttribute('data-prop-decl') || '_Vet diet declaration', 'Accepted v' + version + (summary ? ' — ' + summary : ''));
    setProp(form, gate.getAttribute('data-prop-when') || '_Declaration accepted', sydneyNow() + ' · ' + domain);

    form.__pqVetConfirmed = true;
    close(false);
    // Re-fire through the theme's own path so loading state, cart bridge and drawer behave exactly as a normal add.
    var cta = (trigger && trigger.isConnected && !trigger.disabled) ? trigger : primaryCta(form);
    if (cta) cta.click(); else if (form.requestSubmit) form.requestSubmit(); else form.submit();
    setTimeout(function () { form.__pqVetConfirmed = false; }, 0);
    setTimeout(function () { qa('[data-pq-vet-prop]', form).forEach(function (el) { el.remove(); }); }, 400);
  }
  function primaryCta(form) {
    var t = form.querySelector('[data-to-cart]');
    if (t && t.tagName !== 'BUTTON') t = t.querySelector('button[data-to-cart], button[type="submit"], input[type="submit"]') || t.querySelector('button') || t;
    return t || form.querySelector('button[type="submit"], input[type="submit"]');
  }

  /* ---- interception (capture phase so the theme's own handlers never see an unconfirmed add) ---- */
  function gated(form) {
    if (!form || !adopt()) return false;
    if (!state.section.contains(form)) return false;
    return !form.__pqVetConfirmed;
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('[data-pq-vet-agree]')) { e.preventDefault(); agree(); return; }
    if (t.closest('[data-pq-vet-close]')) { e.preventDefault(); close(true); return; }
    var cta = t.closest(CTA_SEL); if (!cta) return;
    var form = cta.closest('form');
    if (!gated(form)) return;
    if (cta.disabled || cta.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(form, cta);
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.matches || !form.matches(FORM_SEL)) return;
    if (!gated(form)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open(form, null);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.modal && !state.modal.hidden) { e.preventDefault(); close(true); }
    if (e.key === 'Enter' && e.target && e.target.hasAttribute && e.target.hasAttribute('data-pq-vet-pet')) { e.preventDefault(); agree(); }
  });
  document.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-pq-vet-pet')) showError(''); });

  /* ---- keep one-off-only through theme/variant re-renders; re-adopt after editor section loads ---- */
  var mo = new MutationObserver(function () { if (state.section) { clearTimeout(mo.__t); mo.__t = setTimeout(oneOffOnly, 60); } });
  function start() {
    if (adopt()) mo.observe(state.section, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { mo.disconnect(); start(); }, 0); });
})();
